import { FC, useEffect } from "react";
import Typography from "@mui/material/Typography";
import { getSurveySection } from "app/features/surveySlice";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { FormControlModel } from "types";
import FormComponentFactory from "lib/factory/FormComponentFactory";
import { ElementType } from "lib/enums/enums";
import StepContent from "../StepContent";

type Props = {
  formik: any;
  sectionId: number;
};

const Step5: FC<Props> = ({ formik, sectionId }) => {
  const dispatch = useAppDispatch();
  const { surveySection } = useAppSelector((state) => state.survey) ?? [];
  const { questions = [] } = surveySection || {};

  useEffect(() => {
    dispatch(getSurveySection(sectionId));
  }, []);

  const dataModel: Array<FormControlModel> = [
    {
      key: 0,
      formik,
      visible: true,
      name: "transportation",
      label: "¿Cuál es su principal medio de transporte para llegar al trabajo?",
      questionData: questions[0],
      elementType: ElementType.Select,
    },
    {
      key: 1,
      formik,
      visible: true,
      questionData: questions[1],
      name: "transportationTime",
      elementType: ElementType.Select,
      label: "¿Cuánto tarda en movilizarse de la casa a la empresa cada día?",
    },
    {
      key: 2,
      formik,
      visible: true,
      name: "emergencyCorps",
      label: "¿Es brigadista?",
      questionData: questions[2],
      elementType: ElementType.Radio,
    },
    {
      key: 3,
      formik,
      visible: true,
      name: "hasEmploymentFund",
      label: "¿Pertenece a algún fondo de empleados?",
      questionData: questions[3],
      elementType: ElementType.Radio,
    },
  ];
  return (
    <div>
      <Typography mb={2} variant='subtitle1' align='center'>
        Cuéntenos de usted en la empresa: Información ocupacional
      </Typography>
      <StepContent>{dataModel.map(FormComponentFactory)}</StepContent>
    </div>
  );
};

export default Step5;
